import { createContext, useContext } from "react";
const RoutingContext = createContext({ basePath: "/", routes: {} });
RoutingContext.displayName = "RoutingContext";
const useRouting = () => useContext(RoutingContext);
export {
  RoutingContext,
  useRouting
};
//# sourceMappingURL=RoutingContext.js.map
